<template>
  <div>
    <section id="filters">
      <vs-divider position="left">Where</vs-divider>
      <spatial-filter :force-active="true" />
      <vs-divider position="left">Sector</vs-divider>
      <div class="sectors-container">
        <app-radio-list
          class="sectors-radio"
          :items="sectorsList"
          @change="updateActiveSector"
        />
        <img
          :src="
            activeSector.name === sectors.aquaculture.name
              ? require(`@/assets/menus/aquaculture_dark.png`)
              : require(`@/assets/menus/marine_dark.png`)
          "
          class="sector-ico"
        />
      </div>
      <vs-divider position="left">Feature</vs-divider>
      <bluegrowth-future-aqua
        v-show="activeSector.name === sectors.aquaculture.name"
      ></bluegrowth-future-aqua>
      <bluegrowth-future-energy
        v-show="activeSector.name === sectors.energy.name"
      ></bluegrowth-future-energy>
    </section>
  </div>
</template>
<script>
import SpatialFilterControl from "@/components/ui/SpatialFilterControl";
import AppRadioButtonList from "@/components/ui/AppRadioButtonList";
import BlueGrowthFutureAqua from "@/components/BlueGrowthFutureAqua";
import BlueGrowthFutureEnergy from "@/components/BlueGrowthFutureEnergy";
import { SECTORS } from "@/constants.js";
import { mapState, mapActions } from "vuex";

export default {
  components: {
    "spatial-filter": SpatialFilterControl,
    "app-radio-list": AppRadioButtonList,
    "bluegrowth-future-aqua": BlueGrowthFutureAqua,
    "bluegrowth-future-energy": BlueGrowthFutureEnergy
  },
  props: {
    momentId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      activeSector: {},
      sectors: SECTORS,
      sectorsList: []
    };
  },
  computed: {
    ...mapState("map", {
      marker: state => state.marker
    })
  },
  mounted() {
    this.init();
  },
  methods: {
    ...mapActions({
      toggleLoading: "toggleLoading"
    }),
    init() {
      this.setSectorsList();
    },
    setSectorsList() {
      for (const sectorKey of Object.keys(this.sectors)) {
        this.sectorsList.push(this.sectors[sectorKey]);
      }
    },
    updateActiveSector(sector) {
      this.activeSector = sector;
    }
  }
};
</script>
<style scoped>
.sectors-container {
  display: flex;
  margin-right: 1rem;
}
.sectors-radio >>> li {
  padding: 0px !important;
}
.sector-ico {
  width: 50px;
  height: 50px;
}
</style>
